<template>
<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 3.26562V21.2656H21" stroke="#56D0E0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M18 17.2656V9.26562" stroke="#56D0E0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13 17.2656V5.26562" stroke="#56D0E0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8 17.2656V14.2656" stroke="#56D0E0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
